<div class="date-scroller">
  <div class="date-scroller-icon">
    <img src="assets/svg/calendar.svg" class="calendar-icon" />
  </div>
  @if (showLeftArrow) {
    <div class="scroller-arrow scroller-arrow-left" (click)="scrollLeft()">
      <img src="assets/svg/chevron-back-outline.svg" class="scroller-arrow-icon" />
    </div>
  }
  <div class="date-scroller-track" #track (scroll)="onScroll()">
    @for (item of dates; track trackByDate($index, item)) {
      <div
        class="date-cell"
        [class.date-cell-selected]="isInRange(item.date)"
        (click)="selectDate(item)">
        <span class="date-month">{{ item.month }}</span>
        <span class="date-day">{{ item.day }}</span>
        <span class="date-weekday">{{ item.weekday }}</span>
      </div>
    }
  </div>
  @if (showRightArrow) {
    <div class="scroller-arrow scroller-arrow-right" (click)="scrollRight()">
      <img src="assets/svg/chevron-forward-outline.svg" class="scroller-arrow-icon" />
    </div>
  }
</div>
